/** Zod-free constants and helpers, safe to import from the client bundle. */
export const MATCH_CODE_RE = /^RANG-[23456789ABCDEFGHJKMNPQRSTUVWXYZ]{4}$/;
export const AVATAR_KEY_RE = /^[a-f0-9-]{36}\.(webp|jpg|png)$/;
export const MAX_AVATAR_BYTES = 300 * 1024;
export const NAME_MAX = 20;

/** Trims, collapses whitespace and NFC-normalizes so Urdu names compare reliably. */
export function cleanName(name: string): string {
  return name.normalize('NFC').replace(/\s+/g, ' ').trim();
}

export function nameKey(name: string): string {
  return cleanName(name).toLocaleLowerCase();
}
